import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function CTA({ onOpenEnquiry }) {
  const ref = useRef(null);

  useEffect(() => {
    gsap.from(ref.current, {
      opacity: 0, y: 50, duration: 0.9, ease: 'power3.out',
      scrollTrigger: { trigger: ref.current, start: 'top 76%' },
    });
    gsap.from(ref.current.querySelectorAll('.cta-child'), {
      opacity: 0, y: 24, stagger: 0.12, duration: 0.65, ease: 'power3.out',
      scrollTrigger: { trigger: ref.current, start: 'top 70%' },
    });
  }, []);

  return (
    <section id="contact" className="section section-alt">
      <div className="container-sm">
        <div ref={ref} className="cta-card">
          <div className="cta-content">
            <div className="eyebrow cta-child">Limited Slots Available</div>
            <h2 className="heading cta-child">
              Ready to grow
              <br />
              <span className="gradient-text">your business?</span>
            </h2>
            <p className="subtitle cta-child">
              Book a free 30-minute strategy call. We will review your current
              digital presence, map quick wins, and suggest the right build path.
            </p>
            <div className="cta-actions cta-child">
              <button className="btn btn-primary" type="button" onClick={onOpenEnquiry}>
                Book Strategy Call
              </button>
              <a className="btn btn-outline" href="https://wa.me/+919302964803">
                Chat on WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
